const BASE_URL = "/master-data/general-configuration";

export default [

  {
    path: `${BASE_URL}/accounting-period`,
    name: "AccountingPeriodIndex",
    component: () => import("@/pages/masterData/accountingPeriod/Index.vue"),
  },
  {
    path: `${BASE_URL}/inventory-period`,
    name: "InventoryPeriodIndex",
    component: () => import("@/pages/masterData/inventoryPeriod/Index.vue"),
  },
  {
    path: `${BASE_URL}/payment-term`,
    name: "PaymentTermIndex",
    component: () => import("@/pages/masterData/paymentTerm/Index.vue"),
  },
  {
    path: `${BASE_URL}/unit-of-measurement`,
    name: "UnitOfMeasurementIndex",
    component: () => import("@/pages/masterData/unitOfMeasurement/Index.vue"),
  },
  {
    path: `${BASE_URL}/warehouse-location`,
    name: "WarehouseLocationIndex",
    component: () => import("@/pages/masterData/warehouseLocation/Index.vue"),
  },
  {
    path: `${BASE_URL}/bank-account`,
    name: "BankAccountIndex",
    component: () => import("@/pages/masterData/bankAccount/Index.vue"),
  },
  {
    path: `${BASE_URL}/deposit-account`,
    name: "DepositAccountIndex",
    component: () => import("@/pages/masterData/depositAccount/Index.vue"),
  },
  {
    path: `${BASE_URL}/number-series`,
    name: "NumberSeriesIndex",
    component: () => import("@/pages/masterData/numberSeries/Index.vue"),
  },
  {
    path: `${BASE_URL}/purchase-requisition-batch`,
    name: "PurchaseRequisitionBatchIndex",
    component: () => import("@/pages/masterData/purchaseRequisitionBatch/Index.vue"),
  },{
    path: `${BASE_URL}/store-requisition-batch`,
    name: "StoreRequisitionBatchIndex",
    component: () => import("@/pages/masterData/storeRequisitionBatch/Index.vue"),
  },
  {
    path: `${BASE_URL}/general-journal-batch`,
    name: "GeneralJournalBatchIndex",
    component: () => import("@/pages/masterData/generalJournalBatch/Index.vue"),
  }, 
  {
    path: `${BASE_URL}/item-journal-batch`,
    name: "ItemJournalBatchIndex",
    component: () => import("@/pages/masterData/itemJournalBatch/Index.vue"),
  },
  {
    path: `${BASE_URL}/inter-department-transfer-batch`,
    name: "InterDepartmentTransferBatchIndex",
    component: () => import("@/pages/masterData/interDepartmentTransferBatch/Index.vue"),
  },
  {
    path: `${BASE_URL}/report-setting`,
    name: "ReportSettingIndex",
    component: () => import("@/pages/masterData/reportSetting/Index.vue"),
  },
  {
    path: `${BASE_URL}/printout-layout`,
    name: "PrintoutLayoutIndex",
    component: () => import("@/pages/masterData/printoutLayout/Index.vue"),
  },
];
